<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      田心站<br>
站点介绍<br>
田心站位于坪山金田路新田路交叉口，沿坪山金田路东北-西南向布置。站址北侧为地铁16号线田心车辆段，南侧为多为3—5层村民民宅及田心社区居委会；东侧为树山背村，车站周边主要以居住、绿化用地为主。车站设置有3个出入口。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	--	--	16号线	5分33秒	6分55秒<br>
田心	05:56	23:00	16号线	5分33秒	6分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	--	--	16号线	5分50秒	6分钟-9分钟<br>
田心	05:58	23:00	16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	--	--	16号线	5分50秒	6分钟-9分钟<br>
田心	05:58	00:00	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
金田路南侧<br><br>
B出入口:<br>
金田路北侧（东）<br><br>
C出入口:<br>
金田路北侧（西）<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 罗谷居民小组<br>
939B、939、M296、M440、B出入口<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiliuhaoxian",
            title: "16号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>